import wx from 'weixin-js-sdk'

export const send = (_this, info={}, otherInfo={}, recommendType) => {

  const jobNumber =
    info.jobNumber ||
    info.jobPositionNumber ||
    otherInfo.jobNumber ||
    otherInfo.jobPositionNumber
  const customurl =
    `${location.origin}/#/sendSuccess?` +
    `id=${_this.$route.query.id}` +
    `&companyNumber=${
      info.rootCompanyAccountNumber ||
      info.companyNumber ||
      otherInfo.rootCompanyAccountNumber ||
      otherInfo.companyNumber ||
      _this.$route.query.companyNumber}`

  const miniProgramUrl = // 小程序跳转地址
    `/pages/position/detail/detail?number=${jobNumber}` +
    `&redirectUrl=${encodeURIComponent(customurl)}` +
    `&businessPlatformLabel=6` +
    `&businessTagId=xyxx${_this.$route.query.id}` +
    `&productId=9&channelId=5005` +
    `&taskId=xyxx${_this.$route.query.id}` +
    `&refcode=7630`

  // 判断是否运行在微信小程序环境里
  let miniProgram = false
  wx.miniProgram.getEnv(function(res) {
    miniProgram = res.miniprogram
  })
  if (miniProgram) {
    wx.miniProgram.navigateTo({
      url: miniProgramUrl
    })
    return
  }

  // 判断是否运行在支付宝小程序环境里
  console.log('window.my>>>>>', window.my)
  if (window.my) {
    // let aliPayminiProgram = false
    console.log('my>>>>>', my)
    my.getEnv(function (res) {
      console.log('getEnv-res>>>>>', res)
      if (res.miniprogram) {
        my.navigateTo({
          url: miniProgramUrl
        })
      } else {
        mSend(recommendType, jobNumber, customurl, _this, info, otherInfo)
      }
      // aliPayminiProgram = res.miniprogram
    })
    // if (aliPayminiProgram) {
    //   return
    // }
    return
  }

  mSend(recommendType, jobNumber, customurl, _this, info, otherInfo)

  // if (recommendType === 1) {

  //   // 社招
  //   let params =
  //     `?redirectUrl=${encodeURIComponent(customurl)}` +
  //     `&hideDownloadDialog=1` +
  //     `&hideAgreemendDialog=1` + // 隐藏更新公告弹窗
  //     `&businessPlatformLabel=6` +
  //     `&businessTagId=xyxx${_this.$route.query.id}`
  //   const hostname = window.location.hostname
  //   if (hostname === 'xyactivity.zhaopin.com') {
  //     window.location.href = `https://m.zhaopin.com/jobs/${jobNumber}.htm${params}`
  //   } else {
  //     window.location.href = `https://m-pre.zhaopin.com/jobs/${jobNumber}.htm${params}`
  //   }
    
  // } else {

  //   let params =
  //     `?jobNum=${jobNumber}` +
  //     `&rid=${info.rootCompany || otherInfo.rootCompany || info.rootCompanyId}` +
  //     `&pid=${info.jobId || otherInfo.jobId}` +
  //     `&productId=9&channelId=5005` +
  //     `&taskId=xyxx${_this.$route.query.id}` +
  //     `&customurl=${encodeURIComponent(customurl)}`
  //   window.location.href = `https://mxiaoyuan.zhaopin.com/Online/MobileRedirect${params}`
  // }
}

function mSend(recommendType, jobNumber, customurl, _this, info, otherInfo) {

  if (recommendType === 1) {

    // 社招
    let params =
      `?redirectUrl=${encodeURIComponent(customurl)}` +
      `&hideDownloadDialog=1` +
      `&hideAgreemendDialog=1` + // 隐藏更新公告弹窗
      `&businessPlatformLabel=6` +
      `&businessTagId=xyxx${_this.$route.query.id}`
    const hostname = window.location.hostname
    if (hostname === 'xyactivity.zhaopin.com') {
      window.location.href = `https://m.zhaopin.com/jobs/${jobNumber}.htm${params}`
    } else {
      window.location.href = `https://m-pre.zhaopin.com/jobs/${jobNumber}.htm${params}`
    }
    
  } else {

    let params =
      // `?jobNum=${jobNumber}` +
      // `&rid=${info.rootCompany || otherInfo.rootCompany || info.rootCompanyId}` +
      // `&pid=${info.jobId || otherInfo.jobId}` +
      `?pid=${jobNumber}` +
      `&productId=9&channelId=5005` +
      `&taskId=xyxx${_this.$route.query.id}` +
      `&customurl=${encodeURIComponent(customurl)}`
    // window.location.href = `https://mxiaoyuan.zhaopin.com/Online/MobileRedirect${params}`
    window.location.href = `https://campus1.zhaopin.com/Resume/CheckIntoApp${params}` // 兼容新老系统PC及移动
  }
}